// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../../../cms/index.generated';
import { CmsImageSizesFragmentDoc } from '../../../../cms/cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../../cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../../cms/imageSize.fragment.generated';
export const SubMenuItemFragmentDoc = `
    fragment subMenuItem on SubMenuItem {
  title
  link {
    ...link
  }
  media {
    ...cmsImageSizes
  }
  icon {
    ...cmsImageSizes
  }
  style
}
    `;